// extracted by mini-css-extract-plugin
module.exports = {"mw100":"roomstay-blog-featured-card_mw100__z1ItI"};